import {ErrorMessage, Field} from "formik";
import {DatePickerField} from "./date-picker-field";
import {useState} from "react";

export default function FormGroup( {
                                     name,
                                     type="text",
                                     label=null,
                                     checkLabel=null,
                                     placeholder=null,
                                     className=null,
                                     style=null,
                                     children=null,
                                     id=null,
                                     options=[],
                                     optionKey='id',
                                     optionLabel='label',
                                     errors=null,
                                     touched=null,
                                     schema=null,
                                     rows=3,
                                     ...props
                                   } ){


    const [showPlain, setShowPlain] = useState(false);
    const buttonText = showPlain ? "Hide password" : "Show Password";
    const passwordInputType = showPlain ? "text" : "password";

  return (
    <>
        <div className={`form-group ${className}`} style={style}>
          {label && <label htmlFor={`${id ? id : name}`} className="form-label">{label}</label>}

          {['text', 'email'].includes(type) && <Field
            type={type}
            name={name}
            id={`${id ? id : name}`}
            placeholder={placeholder}
            {...props}
            className={`form-control ${errors && touched && errors[name] && touched[name] ? "is-invalid":""}`} />}

            {['password'].includes(type) && <>
                <Field
                    type={passwordInputType}
                    name={name}
                    id={`${id ? id : name}`}
                    placeholder={placeholder}
                    {...props}
                    className={`form-control ${errors && touched && errors[name] && touched[name] ? "is-invalid" : ""}`}/>
                <span className="text-secondary my-1 py-2 fs-7 clickable d-inline-block" onClick={() => setShowPlain(!showPlain)}>{buttonText}</span>
            </>}

            {['date', 'datetime'].includes(type) && <DatePickerField
            name={name}
            id={`${id ? id : name}`}
            placeholder={placeholder}
            className={`form-control ${errors && touched && errors[name] && touched[name] ? "is-invalid":""}`}
          />}

          {['checkbox', 'radio'].includes(type) && <div className={'form-check'}>
            <Field
            type={type}
            name={name}
            id={`${id ? id : name}`}
            placeholder={placeholder}
            className={`form-check-input ${errors && touched && errors[name] && touched[name] ? "is-invalid":""}`} />
            <label htmlFor={`${id ? id : name}`} className="form-check-label">{checkLabel}</label>
          </div>}

          {['textarea'].includes(type) && <Field
            as="textarea"
            rows={rows}
            name={name}
            id={`${id ? id : name}`}
            placeholder={placeholder}
            className={`form-control ${errors && touched && errors[name] && touched[name] ? "is-invalid":""}`} />}

          {'select'===type && <Field
            as="select"
            name={name}
            id={`${id ? id : name}`}
            placeholder={placeholder}
            className={`form-select ${errors && touched && errors[name] && touched[name] ? "is-invalid":""}`} >
              <option value="">{placeholder ? placeholder : '- select option -'}</option>
              {options && options.length && options.map((opt)=>{
                return <option key={`opt-${opt[optionKey]}`} value={opt[optionKey]}>{opt[optionLabel]}</option>
              })}
          </Field>}

          <ErrorMessage name={name} component="div" className="invalid-feedback" />
          {children}
        </div>
    </>
  );
}
